import { DefaultContext, EventObject, MachineConfig, StateSchema } from 'xstate/es';

import { LeadEmailFormStatechartEvent } from 'common/module/lead/email/form/statechart.event';
import { LeadEmailFormStatechartActionEnum } from 'common/module/lead/email/form/statechart/action.enum';
import { LeadEmailFormStatechartStateEnum } from 'common/module/lead/email/form/statechart/state.enum';

// eslint-disable-next-line @propertyfinder/rules/export-name-validation
export const LeadEmailFormStatechart: MachineConfig<DefaultContext, StateSchema, EventObject> = {
  initial: LeadEmailFormStatechartStateEnum.idle,
  states: {
    [LeadEmailFormStatechartStateEnum.idle]: {
      on: {
        [LeadEmailFormStatechartEvent.wantToSendLead]: LeadEmailFormStatechartStateEnum.autoRegisteringUser,
      },
    },
    [LeadEmailFormStatechartStateEnum.executingCaptcha]: {
      onEntry: [LeadEmailFormStatechartActionEnum.executeCaptcha],
      on: {
        [LeadEmailFormStatechartEvent.captchaValueChanged]: LeadEmailFormStatechartStateEnum.autoRegisteringUser,
      },
    },
    [LeadEmailFormStatechartStateEnum.sendingLead]: {
      onEntry: [LeadEmailFormStatechartActionEnum.sendRequestToCreateLead],
      on: {
        [LeadEmailFormStatechartEvent.leadCreateSucceeded]: {
          target: LeadEmailFormStatechartStateEnum.idle,
          actions: [LeadEmailFormStatechartActionEnum.showSuccessMessage],
        },
        [LeadEmailFormStatechartEvent.leadCreateFailed]: {
          target: LeadEmailFormStatechartStateEnum.idle,
          actions: [LeadEmailFormStatechartActionEnum.showErrors, LeadEmailFormStatechartActionEnum.resetCaptcha],
        },
        [LeadEmailFormStatechartEvent.leadRetryWithCaptcha]: LeadEmailFormStatechartStateEnum.executingCaptcha,
      },
    },
    [LeadEmailFormStatechartStateEnum.autoRegisteringUser]: {
      onEntry: [LeadEmailFormStatechartActionEnum.sendAutoRegisterRequest],
      on: {
        [LeadEmailFormStatechartEvent.userIsLoggedIn]: LeadEmailFormStatechartStateEnum.sendingLead,
        [LeadEmailFormStatechartEvent.userSuccessfulyRegistered]: LeadEmailFormStatechartStateEnum.sendingLead,
        // Send lead even if auto registration failed
        [LeadEmailFormStatechartEvent.autoRegistrationFailed]: {
          target: LeadEmailFormStatechartStateEnum.sendingLead,
          actions: [LeadEmailFormStatechartActionEnum.showSignInMessage],
        },
        [LeadEmailFormStatechartEvent.userWasAlreadyRegistered]: {
          target: LeadEmailFormStatechartStateEnum.sendingLead,
          actions: [LeadEmailFormStatechartActionEnum.showSignInMessage],
        },
      },
    },
  },
};
